import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { InstallationDetailsStore } from '@store';
import { OwnershipType } from '@vi-iot/client/models';

@Component({
  selector: 'app-access-list',
  templateUrl: './access-list.component.html',
  styleUrls: ['./access-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessListComponent implements OnInit {
  @Input() installationId: number;
  ownershipType = OwnershipType;

  constructor(public installationDetailsStore: InstallationDetailsStore) {}

  ngOnInit(): void {
    this.installationDetailsStore.getAccountsByCompany();
  }

  getEmployeesList(customerNumber: number, isLoaded: boolean): void {
    if (isLoaded) {
      return;
    }

    this.installationDetailsStore.getMaintainerUsersList(customerNumber);
  }
}
